class EnableIntegration {
  constructor() {
    this.enableIntegration = true;
  }

  ResetAPIIntegration() {
    this.enableIntegration = false;
  }

  ToggleAPIIntegration(apiStatus) {
    this.enableIntegration = apiStatus;
  }

  EnableAPIIntegration() {
    this.enableIntegration = true;
  }

  DisableAPIIntegration() {
    this.enableIntegration = false;
  }

  isAPIIntegrationEnabled() {
    return this.enableIntegration;
  }
}

export default new EnableIntegration();
